export default "__VITE_ASSET__gYFcreg$__"